import { Options, Vue } from 'vue-class-component';
import { isApp } from '@/views/calculators/services/environmentService';

@Options({
	name: 'CookieFooter',
	components: {},
})
export default class CookieFooter extends Vue {
	public isLoggedInAsApp() {
		return isApp();
	}
}
